<script lang="ts">
    import type { SvelteComponent } from 'svelte';
    import cx from 'classnames';

    export let icon: string = '';
    const components = import.meta.glob<SvelteComponent>(`$lib/icons/*.svg`);
    $: iconComponentLoader = components[`/src/lib/icons/${icon}.svg`];
</script>

{#if iconComponentLoader}
    {#await iconComponentLoader()}
        <span class={cx('block h-md w-md', $$props.class)}></span>
    {:then { default: Icon }}
        <Icon class={cx('block', $$props.class)}></Icon>
    {/await}
{/if}
